// extracted by mini-css-extract-plugin
export default {"container":"Inicio_container__qIWxc","GridConhecaMais":"Inicio_GridConhecaMais__1TYtu","titulo":"Inicio_titulo__YHWiA"};